import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {ConsentService} from "../service/consent.service";
import {FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent implements OnInit {

  state = 'loading'
  textConfig: any = {};
  group = ''
  idEmitter = ''

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private consentService: ConsentService) { }

  getLogoUrl(logoName: string) {
    this.consentService.getLogoUrl(this.group, this.textConfig.logoUrl).subscribe(logoUrlResponse => {
      this.consentService.updateLogoUrl(logoUrlResponse.logoUrl);
    });
  }

  decodeUrl(data: string) {
    this.consentService.decodeVerifyEmailUrl(data).subscribe({
      next: (response: any) => {
        this.state = 'loaded';
        const status = (response as any)['status'];
        if (status === 'KO') {
          this.router.navigate(['/error']);
        }
        this.group = (response as any)['group'];
        this.idEmitter = (response as any)['idEmitter'];
        this.textConfig = JSON.parse((response as any)['textConfig']);
        this.getLogoUrl(this.textConfig.logoUrl);
      },
      error: () => {
        this.router.navigate(['/error']);
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        const data = params['data'];
        this.decodeUrl(data);
      });
  }

}
